export default "__VITE_ASSET__D3IzoQ3Z__"